import React from "react";
import BlackKeys from "./BlackKeys";
import WhiteKeys from "./WhiteKeys";

const Keys = () => {

  return (
    <React.Fragment>
      <WhiteKeys />
      <BlackKeys />
    </React.Fragment>
  );
};

export default Keys;